module.exports = __webpack_public_path__ + "img/menu-close.0d7e544b.svg";